import React from "react";

const InvoiceViewer = ({
  selectedInvoice,
  requestItemData,
  viewInvoice,
  setViewInvoice,
}) => {
  // Calculate the grand total from all items
  const calculateGrandTotal = () => {
    if (!requestItemData || !requestItemData.items) return 0;

    return requestItemData.items.reduce((total, item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const rate = parseFloat(item.rate) || 0;
      const itemTotal = quantity * rate;
      return total + itemTotal;
    }, 0);
  };

  // Calculate item total
  const calculateItemTotal = (item) => {
    const quantity = parseFloat(item.quantity) || 0;
    const rate = parseFloat(item.rate) || 0;
    return quantity * rate;
  };

  // Calculate total items
  const totalItems = requestItemData?.items?.length || 0;

  const grandTotal = calculateGrandTotal();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        fontFamily: "'Segoe UI', Roboto, Arial, sans-serif",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
      }}
      onClick={() => {
        viewInvoice && setViewInvoice(false);
      }}
    >
      {/* Invoice Details Container */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          overflow: "hidden",
          margin: "0",
          height: "100%",
        }}
      >
        {/* Invoice Header */}
        <div
          style={{
            backgroundColor: "#f9edc7",
            borderBottom: "1px solid #e0e0e0",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 24px",
          }}
          onClick={() => {
            viewInvoice && setViewInvoice(false);
            !viewInvoice && setViewInvoice(true);
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                color: "#333",
                fontSize: "18px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <span
                style={{
                  backgroundColor: "#3b82f6",
                  width: "28px",
                  height: "28px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {totalItems}
              </span>
              Purchase Order Items
            </h2>
            <p
              style={{
                margin: "8px 0 0 0",
                color: "#666",
                fontSize: "13px",
              }}
            >
              Request ID: {requestItemData?.id || "N/A"}
            </p>
          </div>
          <div style={{ textAlign: "right" }}>
            <h2
              style={{
                margin: 0,
                color: "#333",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              {selectedInvoice?.requestItemData?.projectName.split("-")[0] ||
                "NA"}
            </h2>
            <p
              style={{
                margin: "8px 0 0 0",
                color: "#666",
                fontSize: "13px",
              }}
            >
              {selectedInvoice?.requestItemData?.projectName.split("-")[1] ||
                "NA"}
            </p>
          </div>
        </div>

        {/* Invoice Items */}
        <div
          style={{
            padding: "0 24px",
            flex: 1,
            overflowY: "auto",
            backgroundColor: "#ffffff",
            position: "relative",
          }}
        >
          {/* Table Header */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "3fr 1fr 1fr 1fr 1fr",
              padding: "16px 0",
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e0e0e0",
              fontWeight: "600",
              fontSize: "14px",
              color: "#555",
              position: "sticky",
              top: 0,
              zIndex: 10,
              boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
            }}
          >
            <div>Description</div>
            <div style={{ textAlign: "center" }}>Qty</div>
            <div style={{ textAlign: "center" }}>Unit</div>
            <div style={{ textAlign: "right" }}>Rate</div>
            <div style={{ textAlign: "right" }}>Amount</div>
          </div>

          {/* Item Rows Container */}
          <div style={{ maxHeight: "calc(100vh - 260px)", overflowY: "auto" }}>
            {/* Item Rows */}
            {requestItemData?.items?.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "3fr 1fr 1fr 1fr 1fr",
                  padding: "16px 0",
                  borderBottom: "1px solid #eee",
                  fontSize: "14px",
                  color: "#333",
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
                  transition: "background-color 0.2s",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f3f4f6";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor =
                    index % 2 === 0 ? "#ffffff" : "#f9fafb";
                }}
              >
                <div>
                  <div style={{ fontWeight: "500", color: "#333" }}>
                    {item.category}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#666",
                      marginTop: "6px",
                      lineHeight: "1.4",
                    }}
                  >
                    {item.description}
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>{item.quantity}</div>
                <div style={{ textAlign: "center" }}>{item.unit}</div>
                <div style={{ textAlign: "right" }}>
                  {parseFloat(item.rate)
                    ? `₹${parseFloat(item.rate).toFixed(2)}`
                    : "N/A"}
                </div>
                <div
                  style={{
                    textAlign: "right",
                    fontWeight: "600",
                    color: "#1d4ed8",
                  }}
                >
                  {parseFloat(item.rate)
                    ? `₹${calculateItemTotal(item).toFixed(2)}`
                    : "N/A"}
                </div>
              </div>
            ))}

            {/* No items message */}
            {(!requestItemData?.items ||
              requestItemData.items.length === 0) && (
              <div
                style={{
                  padding: "40px 0",
                  textAlign: "center",
                  color: "#999",
                  backgroundColor: "#fafafa",
                  borderRadius: "8px",
                  margin: "20px 0",
                }}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#999"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginBottom: "12px" }}
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p style={{ fontWeight: "500", fontSize: "16px", margin: "0" }}>
                  No items found in this request
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Invoice Footer - Totals */}
        <div
          style={{
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#ffffff",
            marginTop: "auto",
            position: "relative",
            zIndex: 2,
            borderBottomLeftRadius: "12px",
            borderBottomRightRadius: "12px",
            boxShadow: "0 -4px 12px rgba(0,0,0,0.03)",
          }}
        >
          {/* Grand Total Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "24px",
              backgroundColor: "#f8f9fa",
              borderBottomLeftRadius: "12px",
              borderBottomRightRadius: "12px",
            }}
          >
            {/* Status Section */}
            <div style={{ flex: "1" }}>
              {requestItemData?.requestHistory && (
                <div
                  style={{
                    backgroundColor: "#eef7ff",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    fontSize: "13px",
                    color: "#4a6f8a",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                    border: "1px solid #e0e9f0",
                  }}
                >
                  <div style={{ fontWeight: "600", marginBottom: "6px" }}>
                    Request Status
                  </div>
                  {Object.keys(requestItemData.requestHistory).length > 0
                    ? `Last updated by: ${
                        requestItemData.requestHistory[
                          Object.keys(requestItemData.requestHistory).pop()
                        ]?.name || "Unknown"
                      }`
                    : "No status updates available"}
                </div>
              )}
            </div>

            {/* Total Amount Section */}
            <div
              style={{
                minWidth: "240px",
                textAlign: "right",
                paddingLeft: "24px",
              }}
            >
              <div
                style={{
                  marginBottom: "8px",
                  color: "#6b7280",
                  fontSize: "14px",
                }}
              >
                Total Items:{" "}
                <span style={{ fontWeight: "600", color: "#333" }}>
                  {totalItems}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  marginTop: "16px",
                  backgroundColor: "#f0f5ff",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(29, 78, 216, 0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "600",
                    color: "#333",
                    marginRight: "16px",
                  }}
                >
                  Grand Total:
                </div>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "700",
                    color: "#1d4ed8",
                  }}
                >
                  ₹{grandTotal.toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceViewer;
